import React, { SVGProps } from 'react';

const SupportCenterIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={19}
    height={17}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    data-palette="SupportCenterIcon">
    <path
      d="M17.333 9.667h-1.666V4.032L9.06 9.948 2.333 4.013v9.82h8.334V15.5H1.5a.833.833 0 0 1-.833-.833V1.333A.833.833 0 0 1 1.5.5h15a.833.833 0 0 1 .833.833v8.334ZM2.76 2.167l6.292 5.551 6.2-5.551H2.76Zm12.074 14.166-2.946-2.946 1.179-1.179 1.767 1.769 2.947-2.947 1.178 1.178-4.125 4.125Z"
      fill="var(--dropdownIconColor)"
      stroke="var(--walletMenuBackground)"
      strokeWidth={0.6}
    />
  </svg>
);

export default SupportCenterIcon;
